import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Stack,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../../api/axios";

const VendorOrders = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);

  const vendorUser = JSON.parse(localStorage.getItem("user"));
  // console.log("Vendor user:", vendorUser);
  useEffect(() => {
    if (!vendorUser?._id) {
      navigate("/vendor/login", { replace: true });
      return;
    }

    fetchVendorOrders();
  }, []);

  const fetchVendorOrders = async () => {
    try {
      const { data } = await api.get("/vendor/orders", {
        params: { vendorId: vendorUser._id },
      });

      setOrders(data);
    } catch (err) {
      console.error(
        err.response?.data?.message || "Failed to load orders"
      );
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" fontWeight={700} mb={3}>
        Orders Assigned to You
      </Typography>

      {orders.length === 0 && (
        <Typography>No new orders yet</Typography>
      )}

      <Stack spacing={2}>
        {orders.map(order => (
          <Card key={order._id}>
            <CardContent>
              <Typography fontWeight={600}>
                Order ID: {order._id}
              </Typography>

              <Typography variant="body2">
                Items: {order.items?.length || 0}
              </Typography>

              <Typography variant="body2">
                Total: ₹{Number(order.total).toLocaleString("en-IN")}
              </Typography>

              <Chip
                label={order.tracking?.at(-1)?.label || "Order Placed"}
                color="warning"
                sx={{ mt: 1 }}
              />

              <Stack direction="row" spacing={2} mt={2}>
                {order.status === "ORDER_PLACED" && (
                  <Button
                    variant="contained"
                    onClick={() =>
                      navigate(`/vendor/orders/${order._id}`)
                    }
                  >
                    Review & Accept
                  </Button>
                )}

                <Button
                  variant="outlined"
                  onClick={() =>
                    navigate(`/vendor/orders/${order._id}`)
                  }
                >
                  View Details
                </Button>
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default VendorOrders;
